'use client';

import { useDecisions } from '../../hooks';
import { MedalliaLegacy } from './medallia-legacy';

export const MedalliaScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <MedalliaLegacy />;
};
